<div class="login-container">
  <!-- Logo Section -->
  <div class="logo-section">
    <img class="logo" src="/assets/img/fleetoperate_logo.jpg" alt="FleetOperate Logo" />
  </div>

  <div class="login-card">
    <!-- Main Content -->
    <div class="login-content">
      <!-- Error Message -->
      @if (verificationRequired) {
        <section class="verification-section" aria-labelledby="verification-title">
          <div class="verification-prompt" role="alert">
            <mat-icon aria-hidden="true">mark_email_unread</mat-icon>
            <div>
              <h2 id="verification-title">Verify your email</h2>
              <p>{{ errorMessage }}</p>
            </div>
          </div>

          <button
            mat-raised-button
            color="primary"
            type="button"
            class="resend-verification-button"
            [disabled]="resendVerificationLoading || resendVerificationCooldown"
            (click)="resendVerificationEmail()"
            data-test="resend-verification-button"
            >
            <mat-icon aria-hidden="true">{{ resendVerificationLoading ? 'hourglass_empty' : 'send' }}</mat-icon>
            <span>{{ resendVerificationLoading ? 'Sending...' : 'Resend verification email' }}</span>
          </button>
        </section>
      } @else if (errorMessage) {
        <mat-error class="error-message" data-test="form-error-message">
          <mat-icon>error</mat-icon>
          {{ errorMessage }}
        </mat-error>
      }

      <!-- Sign In Form -->
      <form [formGroup]="form" #signinForm="ngForm" (ngSubmit)="onSubmit(signinForm)" class="login-form">
        <div class="form-fields">
          <!-- Email Field -->
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Email Address</mat-label>
            <input
              type="email"
              #email
              inputmode="email"
              matInput
              formControlName="email"
              data-testid="email-form-field"
              data-test="email-form-field"
              autocomplete="email"
              />
            <mat-icon matPrefix>email</mat-icon>
            @if (form.get('email')?.touched && form.get('email')?.invalid) {
              <mat-error data-test="email-error-field">
                {{ getEmailErrorMessage() }}
              </mat-error>
            }
          </mat-form-field>

          <!-- Password Field -->
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Password</mat-label>
            <input
              matInput
              [type]="hidePassword ? 'password' : 'text'"
              formControlName="password"
              data-test="password-form-field"
              data-testid="password-form-field"
              autocomplete="current-password"
              />
            <mat-icon matPrefix>lock</mat-icon>
            <mat-icon
              matSuffix
              (click)="hidePassword = !hidePassword"
              data-test="password-visibility-button"
              class="password-toggle"
              >
              {{ hidePassword ? 'visibility' : 'visibility_off' }}
            </mat-icon>
            <mat-hint>At least 8 characters</mat-hint>
            @if (form.get('password')?.touched && form.get('password')?.invalid) {
              <mat-error data-testid="password-error-field" data-test="password-error-field">
                {{ getPasswordErrorMessage() }}
              </mat-error>
            }
          </mat-form-field>
        </div>

        <!-- Forgot Password & Help Links -->
        <div class="action-links">
          <a [routerLink]="[]" (click)="onNavigateToForgotPassword()" data-test="forgot-password-link" class="link">
            Forgot password?
          </a>
          <a [routerLink]="[]" (click)="onNavigateToHelp()" class="link">
            Need help?
          </a>
        </div>

        <!-- Sign In Button -->
        <button
          mat-raised-button
          color="primary"
          type="submit"
          class="signin-button"
          [disabled]="form.pristine || !form.valid || loading"
          data-test="login-button"
          data-testid="login-button"
          >
          @if (loading) {
            <mat-icon>hourglass_empty</mat-icon>
          }
          @if (!loading) {
            <span>Sign In</span>
          }
          @if (loading) {
            <span>Signing In...</span>
          }
        </button>

        <!-- Terms and Conditions -->
        <div class="terms-text">
          By clicking Sign in, you agree to our
          <a [routerLink]="[]" (click)="onNavigateToTermsConditions()" class="link">Terms and Conditions</a> and
          <a [routerLink]="[]" (click)="onNavigateToPrivacyStatement()" class="link">Privacy Statement</a>
        </div>
      </form>
    </div>

    <!-- Sign Up Link -->
    <div class="signup-section">
      <p class="signup-text">
        Don't have an account?
        <a [routerLink]="[]" (click)="onNavigateToSignUp()" data-test="signup-link" class="signup-link">
          Sign up
        </a>
      </p>
    </div>

    <!-- reCAPTCHA Terms -->
    <div class="recaptcha-terms">
      This site is protected by reCAPTCHA and the Google
      <a href="https://policies.google.com/privacy" class="recaptcha-link">Privacy Policy</a> and
      <a href="https://policies.google.com/terms" class="recaptcha-link">Terms of Service</a> apply.
    </div>
  </div>
</div>
